export * from './aMFIU.service';
import { AMFIUService } from './aMFIU.service';
export * from './aboutSaccosPolicy.service';
import { AboutSaccosPolicyService } from './aboutSaccosPolicy.service';
export * from './account.service';
import { AccountService } from './account.service';
export * from './accountStatus.service';
import { AccountStatusService } from './accountStatus.service';
export * from './accountTransactions.service';
import { AccountTransactionsService } from './accountTransactions.service';
export * from './adminUser.service';
import { AdminUserService } from './adminUser.service';
export * from './apex.service';
import { ApexService } from './apex.service';
export * from './appModule.service';
import { AppModuleService } from './appModule.service';
export * from './appModuleFeature.service';
import { AppModuleFeatureService } from './appModuleFeature.service';
export * from './assetAllocation.service';
import { AssetAllocationService } from './assetAllocation.service';
export * from './audit.service';
import { AuditService } from './audit.service';
export * from './auditLog.service';
import { AuditLogService } from './auditLog.service';
export * from './blockEmailAddressAppservice.service';
import { BlockEmailAddressAppserviceService } from './blockEmailAddressAppservice.service';
export * from './branch.service';
import { BranchService } from './branch.service';
export * from './bulkTransaction.service';
import { BulkTransactionService } from './bulkTransaction.service';
export * from './camsAuth.service';
import { CamsAuthService } from './camsAuth.service';
export * from './camsTransaction.service';
import { CamsTransactionService } from './camsTransaction.service';
export * from './chargeType.service';
import { ChargeTypeService } from './chargeType.service';
export * from './clientLoan.service';
import { ClientLoanService } from './clientLoan.service';
export * from './clientManager.service';
import { ClientManagerService } from './clientManager.service';
export * from './clientRegistration.service';
import { ClientRegistrationService } from './clientRegistration.service';
export * from './clientStatus.service';
import { ClientStatusService } from './clientStatus.service';
export * from './clientType.service';
import { ClientTypeService } from './clientType.service';
export * from './clientUser.service';
import { ClientUserService } from './clientUser.service';
export * from './configuration.service';
import { ConfigurationService } from './configuration.service';
export * from './creditProductPolicy.service';
import { CreditProductPolicyService } from './creditProductPolicy.service';
export * from './creditUnion.service';
import { CreditUnionService } from './creditUnion.service';
export * from './creditUnionAssociated.service';
import { CreditUnionAssociatedService } from './creditUnionAssociated.service';
export * from './creditUnionCharge.service';
import { CreditUnionChargeService } from './creditUnionCharge.service';
export * from './creditUnionConfiguration.service';
import { CreditUnionConfigurationService } from './creditUnionConfiguration.service';
export * from './creditUnionFeature.service';
import { CreditUnionFeatureService } from './creditUnionFeature.service';
export * from './creditUnionFinancialData.service';
import { CreditUnionFinancialDataService } from './creditUnionFinancialData.service';
export * from './creditUnionGet.service';
import { CreditUnionGetService } from './creditUnionGet.service';
export * from './creditUnionGroup.service';
import { CreditUnionGroupService } from './creditUnionGroup.service';
export * from './creditUnionMember.service';
import { CreditUnionMemberService } from './creditUnionMember.service';
export * from './creditUnionMemberCharge.service';
import { CreditUnionMemberChargeService } from './creditUnionMemberCharge.service';
export * from './creditUnionMemberDetail.service';
import { CreditUnionMemberDetailService } from './creditUnionMemberDetail.service';
export * from './creditUnionMemberDocument.service';
import { CreditUnionMemberDocumentService } from './creditUnionMemberDocument.service';
export * from './creditUnionMemberSearch.service';
import { CreditUnionMemberSearchService } from './creditUnionMemberSearch.service';
export * from './creditUnionMemberSummary.service';
import { CreditUnionMemberSummaryService } from './creditUnionMemberSummary.service';
export * from './creditUnionMigration.service';
import { CreditUnionMigrationService } from './creditUnionMigration.service';
export * from './creditUnionPaymentProvider.service';
import { CreditUnionPaymentProviderService } from './creditUnionPaymentProvider.service';
export * from './creditUnionStatus.service';
import { CreditUnionStatusService } from './creditUnionStatus.service';
export * from './creditUnionUpdate.service';
import { CreditUnionUpdateService } from './creditUnionUpdate.service';
export * from './creditUnoinUser.service';
import { CreditUnoinUserService } from './creditUnoinUser.service';
export * from './creditunionDocument.service';
import { CreditunionDocumentService } from './creditunionDocument.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './externalAuthService.service';
import { ExternalAuthServiceService } from './externalAuthService.service';
export * from './externalCredit.service';
import { ExternalCreditService } from './externalCredit.service';
export * from './file.service';
import { FileService } from './file.service';
export * from './financialDataApproval.service';
import { FinancialDataApprovalService } from './financialDataApproval.service';
export * from './groupAssetsService.service';
import { GroupAssetsServiceService } from './groupAssetsService.service';
export * from './groupDetailService.service';
import { GroupDetailServiceService } from './groupDetailService.service';
export * from './groupDetailsSave.service';
import { GroupDetailsSaveService } from './groupDetailsSave.service';
export * from './groupDocumentService.service';
import { GroupDocumentServiceService } from './groupDocumentService.service';
export * from './groupLoan.service';
import { GroupLoanService } from './groupLoan.service';
export * from './groupMemberService.service';
import { GroupMemberServiceService } from './groupMemberService.service';
export * from './holidays.service';
import { HolidaysService } from './holidays.service';
export * from './hostUser.service';
import { HostUserService } from './hostUser.service';
export * from './interestRate.service';
import { InterestRateService } from './interestRate.service';
export * from './investmentProduct.service';
import { InvestmentProductService } from './investmentProduct.service';
export * from './invoice.service';
import { InvoiceService } from './invoice.service';
export * from './job.service';
import { JobService } from './job.service';
export * from './loan.service';
import { LoanService } from './loan.service';
export * from './loanAccountDetails.service';
import { LoanAccountDetailsService } from './loanAccountDetails.service';
export * from './loanAccrued.service';
import { LoanAccruedService } from './loanAccrued.service';
export * from './loanApplication.service';
import { LoanApplicationService } from './loanApplication.service';
export * from './loanApplicationCharge.service';
import { LoanApplicationChargeService } from './loanApplicationCharge.service';
export * from './loanApplicationCreate.service';
import { LoanApplicationCreateService } from './loanApplicationCreate.service';
export * from './loanApplicationDetail.service';
import { LoanApplicationDetailService } from './loanApplicationDetail.service';
export * from './loanApplicationDocument.service';
import { LoanApplicationDocumentService } from './loanApplicationDocument.service';
export * from './loanApplicationList.service';
import { LoanApplicationListService } from './loanApplicationList.service';
export * from './loanApplicationMember.service';
import { LoanApplicationMemberService } from './loanApplicationMember.service';
export * from './loanApplicationSchedule.service';
import { LoanApplicationScheduleService } from './loanApplicationSchedule.service';
export * from './loanApplicationStage.service';
import { LoanApplicationStageService } from './loanApplicationStage.service';
export * from './loanApplicationStatus.service';
import { LoanApplicationStatusService } from './loanApplicationStatus.service';
export * from './loanBalance.service';
import { LoanBalanceService } from './loanBalance.service';
export * from './loanCharges.service';
import { LoanChargesService } from './loanCharges.service';
export * from './loanCollateral.service';
import { LoanCollateralService } from './loanCollateral.service';
export * from './loanConst.service';
import { LoanConstService } from './loanConst.service';
export * from './loanDetail.service';
import { LoanDetailService } from './loanDetail.service';
export * from './loanDisbursement.service';
import { LoanDisbursementService } from './loanDisbursement.service';
export * from './loanDocument.service';
import { LoanDocumentService } from './loanDocument.service';
export * from './loanGuarantor.service';
import { LoanGuarantorService } from './loanGuarantor.service';
export * from './loanInstallment.service';
import { LoanInstallmentService } from './loanInstallment.service';
export * from './loanInsurance.service';
import { LoanInsuranceService } from './loanInsurance.service';
export * from './loanList.service';
import { LoanListService } from './loanList.service';
export * from './loanMember.service';
import { LoanMemberService } from './loanMember.service';
export * from './loanOfficer.service';
import { LoanOfficerService } from './loanOfficer.service';
export * from './loanOverPaidAmount.service';
import { LoanOverPaidAmountService } from './loanOverPaidAmount.service';
export * from './loanProduct.service';
import { LoanProductService } from './loanProduct.service';
export * from './loanProvisioning.service';
import { LoanProvisioningService } from './loanProvisioning.service';
export * from './loanRepayment.service';
import { LoanRepaymentService } from './loanRepayment.service';
export * from './loanReschedule.service';
import { LoanRescheduleService } from './loanReschedule.service';
export * from './loanSectorType.service';
import { LoanSectorTypeService } from './loanSectorType.service';
export * from './loanStatement.service';
import { LoanStatementService } from './loanStatement.service';
export * from './loanTopUp.service';
import { LoanTopUpService } from './loanTopUp.service';
export * from './loanType.service';
import { LoanTypeService } from './loanType.service';
export * from './loanUpdate.service';
import { LoanUpdateService } from './loanUpdate.service';
export * from './memberBankAccount.service';
import { MemberBankAccountService } from './memberBankAccount.service';
export * from './memberDetails.service';
import { MemberDetailsService } from './memberDetails.service';
export * from './memberDetailsAssets.service';
import { MemberDetailsAssetsService } from './memberDetailsAssets.service';
export * from './memberDetailsIncome.service';
import { MemberDetailsIncomeService } from './memberDetailsIncome.service';
export * from './memberDetailsResidence.service';
import { MemberDetailsResidenceService } from './memberDetailsResidence.service';
export * from './memberDetailsSavings.service';
import { MemberDetailsSavingsService } from './memberDetailsSavings.service';
export * from './memberDetailsShare.service';
import { MemberDetailsShareService } from './memberDetailsShare.service';
export * from './memberFinancialData.service';
import { MemberFinancialDataService } from './memberFinancialData.service';
export * from './memberKyc.service';
import { MemberKycService } from './memberKyc.service';
export * from './memberKycDocument.service';
import { MemberKycDocumentService } from './memberKycDocument.service';
export * from './memberMno.service';
import { MemberMnoService } from './memberMno.service';
export * from './memberTreasury.service';
import { MemberTreasuryService } from './memberTreasury.service';
export * from './membershipPolicy.service';
import { MembershipPolicyService } from './membershipPolicy.service';
export * from './notification.service';
import { NotificationService } from './notification.service';
export * from './onlineTransaction.service';
import { OnlineTransactionService } from './onlineTransaction.service';
export * from './organizationChargeConfig.service';
import { OrganizationChargeConfigService } from './organizationChargeConfig.service';
export * from './overdueLoanCategory.service';
import { OverdueLoanCategoryService } from './overdueLoanCategory.service';
export * from './payTransaction.service';
import { PayTransactionService } from './payTransaction.service';
export * from './payment.service';
import { PaymentService } from './payment.service';
export * from './paymentProvider.service';
import { PaymentProviderService } from './paymentProvider.service';
export * from './paymentTransactionMode.service';
import { PaymentTransactionModeService } from './paymentTransactionMode.service';
export * from './paymentTypeConfiguration.service';
import { PaymentTypeConfigurationService } from './paymentTypeConfiguration.service';
export * from './payrollDeduction.service';
import { PayrollDeductionService } from './payrollDeduction.service';
export * from './policyApproval.service';
import { PolicyApprovalService } from './policyApproval.service';
export * from './policyMemberAcceptance.service';
import { PolicyMemberAcceptanceService } from './policyMemberAcceptance.service';
export * from './policyVersion.service';
import { PolicyVersionService } from './policyVersion.service';
export * from './reconcile.service';
import { ReconcileService } from './reconcile.service';
export * from './report.service';
import { ReportService } from './report.service';
export * from './request.service';
import { RequestService } from './request.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './savingAccount.service';
import { SavingAccountService } from './savingAccount.service';
export * from './savingConst.service';
import { SavingConstService } from './savingConst.service';
export * from './savingProduct.service';
import { SavingProductService } from './savingProduct.service';
export * from './security.service';
import { SecurityService } from './security.service';
export * from './serviceProvider.service';
import { ServiceProviderService } from './serviceProvider.service';
export * from './session.service';
import { SessionService } from './session.service';
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './shareAccount.service';
import { ShareAccountService } from './shareAccount.service';
export * from './shareType.service';
import { ShareTypeService } from './shareType.service';
export * from './teller.service';
import { TellerService } from './teller.service';
export * from './tellerAccount.service';
import { TellerAccountService } from './tellerAccount.service';
export * from './tellerGuarantorAccount.service';
import { TellerGuarantorAccountService } from './tellerGuarantorAccount.service';
export * from './tellerProduct.service';
import { TellerProductService } from './tellerProduct.service';
export * from './tellerRequest.service';
import { TellerRequestService } from './tellerRequest.service';
export * from './tellerTransaction.service';
import { TellerTransactionService } from './tellerTransaction.service';
export * from './tenant.service';
import { TenantService } from './tenant.service';
export * from './tokenAuth.service';
import { TokenAuthService } from './tokenAuth.service';
export * from './transaction.service';
import { TransactionService } from './transaction.service';
export * from './transactionFee.service';
import { TransactionFeeService } from './transactionFee.service';
export * from './transactionFeeConfiguration.service';
import { TransactionFeeConfigurationService } from './transactionFeeConfiguration.service';
export * from './transactionSecurity.service';
import { TransactionSecurityService } from './transactionSecurity.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './userAcceptInvite.service';
import { UserAcceptInviteService } from './userAcceptInvite.service';
export * from './userAccount.service';
import { UserAccountService } from './userAccount.service';
export * from './userActivatation.service';
import { UserActivatationService } from './userActivatation.service';
export * from './userDevice.service';
import { UserDeviceService } from './userDevice.service';
export * from './userInvite.service';
import { UserInviteService } from './userInvite.service';
export * from './userSettings.service';
import { UserSettingsService } from './userSettings.service';
export * from './ussd.service';
import { UssdService } from './ussd.service';
export * from './ussdLoan.service';
import { UssdLoanService } from './ussdLoan.service';
export * from './ussdSaving.service';
import { UssdSavingService } from './ussdSaving.service';
export * from './ussdShares.service';
import { UssdSharesService } from './ussdShares.service';
export * from './wakandiAuth.service';
import { WakandiAuthService } from './wakandiAuth.service';
export const APIS = [AMFIUService, AboutSaccosPolicyService, AccountService, AccountStatusService, AccountTransactionsService, AdminUserService, ApexService, AppModuleService, AppModuleFeatureService, AssetAllocationService, AuditService, AuditLogService, BlockEmailAddressAppserviceService, BranchService, BulkTransactionService, CamsAuthService, CamsTransactionService, ChargeTypeService, ClientLoanService, ClientManagerService, ClientRegistrationService, ClientStatusService, ClientTypeService, ClientUserService, ConfigurationService, CreditProductPolicyService, CreditUnionService, CreditUnionAssociatedService, CreditUnionChargeService, CreditUnionConfigurationService, CreditUnionFeatureService, CreditUnionFinancialDataService, CreditUnionGetService, CreditUnionGroupService, CreditUnionMemberService, CreditUnionMemberChargeService, CreditUnionMemberDetailService, CreditUnionMemberDocumentService, CreditUnionMemberSearchService, CreditUnionMemberSummaryService, CreditUnionMigrationService, CreditUnionPaymentProviderService, CreditUnionStatusService, CreditUnionUpdateService, CreditUnoinUserService, CreditunionDocumentService, DashboardService, ExternalAuthServiceService, ExternalCreditService, FileService, FinancialDataApprovalService, GroupAssetsServiceService, GroupDetailServiceService, GroupDetailsSaveService, GroupDocumentServiceService, GroupLoanService, GroupMemberServiceService, HolidaysService, HostUserService, InterestRateService, InvestmentProductService, InvoiceService, JobService, LoanService, LoanAccountDetailsService, LoanAccruedService, LoanApplicationService, LoanApplicationChargeService, LoanApplicationCreateService, LoanApplicationDetailService, LoanApplicationDocumentService, LoanApplicationListService, LoanApplicationMemberService, LoanApplicationScheduleService, LoanApplicationStageService, LoanApplicationStatusService, LoanBalanceService, LoanChargesService, LoanCollateralService, LoanConstService, LoanDetailService, LoanDisbursementService, LoanDocumentService, LoanGuarantorService, LoanInstallmentService, LoanInsuranceService, LoanListService, LoanMemberService, LoanOfficerService, LoanOverPaidAmountService, LoanProductService, LoanProvisioningService, LoanRepaymentService, LoanRescheduleService, LoanSectorTypeService, LoanStatementService, LoanTopUpService, LoanTypeService, LoanUpdateService, MemberBankAccountService, MemberDetailsService, MemberDetailsAssetsService, MemberDetailsIncomeService, MemberDetailsResidenceService, MemberDetailsSavingsService, MemberDetailsShareService, MemberFinancialDataService, MemberKycService, MemberKycDocumentService, MemberMnoService, MemberTreasuryService, MembershipPolicyService, NotificationService,OnlineTransactionService, OrganizationChargeConfigService, OverdueLoanCategoryService, PayTransactionService, PaymentService,PaymentTransactionModeService, PaymentProviderService, PaymentTypeConfigurationService, PayrollDeductionService, PolicyApprovalService, PolicyMemberAcceptanceService, PolicyVersionService, ReconcileService, ReportService, RequestService, RoleService, SavingAccountService, SavingConstService, SavingProductService, SecurityService, ServiceProviderService, SessionService, SettingsService, ShareAccountService, ShareTypeService, TellerService, TellerAccountService, TellerGuarantorAccountService, TellerProductService, TellerRequestService, TellerTransactionService, TenantService, TokenAuthService, TransactionService, TransactionFeeService, TransactionFeeConfigurationService, TransactionSecurityService, UserService, UserAcceptInviteService, UserAccountService, UserActivatationService, UserDeviceService, UserInviteService, UserSettingsService, UssdService, UssdLoanService, UssdSavingService, UssdSharesService, WakandiAuthService];
